export const stateName = 'checkout';
export let DeliveryType;

(function (DeliveryType) {
  DeliveryType[DeliveryType["Home"] = 1] = "Home";
  DeliveryType[DeliveryType["PickupPoint"] = 2] = "PickupPoint";
  DeliveryType[DeliveryType["NoShipping"] = 3] = "NoShipping";
  DeliveryType[DeliveryType["Custom"] = 4] = "Custom";
})(DeliveryType || (DeliveryType = {}));

export let DeliveryOption;

(function (DeliveryOption) {
  DeliveryOption["Pickup"] = "pickup";
  DeliveryOption["Home"] = "home";
  DeliveryOption["Meetup"] = "meetup";
  DeliveryOption["Custom"] = "custom";
})(DeliveryOption || (DeliveryOption = {}));

export let FieldName;

(function (FieldName) {
  FieldName["Address"] = "to_address";
  FieldName["PickupPoint"] = "pickup_point";
  FieldName["PaymentMethod"] = "payment_method";
})(FieldName || (FieldName = {}));

export let PickupModalElement;

(function (PickupModalElement) {
  PickupModalElement["Modal"] = "modal";
  PickupModalElement["SearchArea"] = "search_area";
  PickupModalElement["UserLocation"] = "user_location";
  PickupModalElement["Search"] = "search";
})(PickupModalElement || (PickupModalElement = {}));

export const PAYMENT_POLL_DELAY = 1000;
export const MAX_PAYMENT_POLL_ATTEMPT_COUNT = 5;
export const CREDIT_CARD_EVENT_TRACKING_CODE = 'cc';